import { CommerceButtonRenderDetails } from '@themaven-net/commerce-published-webcomponents';
import {
    CommerceEmbedSharedOptions,
    CommerceItem,
    CommerceOffer,
    CtaEmbedConfig,
    isCommerceOffer,
    LinkEmbedConfig,
    selectBestOffers,
} from '@themaven-net/commerce-shared';
import { html, nothing, TemplateResult } from 'lit';

export function parseItemForOffers(
    item: CommerceItem,
    chooseBestOffer: boolean | undefined
): CommerceOffer[] {
    if (item.offers && item.offers.length > 1 && chooseBestOffer) {
        const bestOffers = selectBestOffers(
            item.offers as CommerceOffer[],
            3,
            window?.phxCommerce?.preferredMerchants,
            window?.phxCommerce?.preferredAffiliates
        );
        if (bestOffers.length > 1) {
            return bestOffers;
        }
    }

    return item.offers as CommerceOffer[];
}

export function renderCommerceLink(
    contents: string | TemplateResult,
    linkDestination: string | CommerceOffer,
    item?: CommerceItem,
    options?: CommerceEmbedSharedOptions,
    hidden = false,
    extraAttributes?: Record<string, string>,
    classes?: string
): TemplateResult {
    if (linkDestination === undefined) {
        return html`${contents}`;
    }

    classes ??= '';
    const config: LinkEmbedConfig = { item, options };

    if (isCommerceOffer(linkDestination)) {
        config.offer = linkDestination;
    }

    return html`<phoenix-commerce-link
        classnames="${classes}"
        href="${typeof linkDestination === 'string' ? linkDestination : nothing}"
        rel="nofollow noopener noreferrer"
        target="_blank"
        .dynamicAttrs=${extraAttributes}
        .config=${config}
        ?hidden=${hidden}
        >${contents}</phoenix-commerce-link
    >`;
}

export function renderCommerceCta(
    offerDetails: CommerceButtonRenderDetails,
    item?: CommerceItem,
    options?: CommerceEmbedSharedOptions,
    classes?: string,
    linkExtraAttributes?: Record<string, string>,
    linkClasses: string | undefined = 'm-product-offers--buy-button m-button is-inverted'
): TemplateResult {
    if (offerDetails === undefined || offerDetails.text === undefined) {
        return html``;
    }

    const config: CtaEmbedConfig = {
        ctaText: offerDetails.text,
        item: item,
        offer: offerDetails.offer,
        options: options,
    };

    const link = renderCommerceLink(
        offerDetails.text,
        offerDetails.offer,
        item,
        options,
        false,
        linkExtraAttributes,
        linkClasses
    );

    // rely on slot adoption as it is cleaner
    return html`<phoenix-commerce-cta classes="${classes ?? ''}" .config=${config}>
        ${link}
    </phoenix-commerce-cta>`;
}
